import React, { useState } from "react";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { Space } from "../../../space/Space";
import { EditCoverPage } from "./EditCoverPage";
import { displayCoverPageConfig } from "./formConfig";
import { CoverPageProps, CoverPageData, DisplayConfig } from "./types";

export const CoverPage: React.FC<CoverPageProps> = ({ data }) => {
    const [openEditCoverModal, setOpenEditCoverModal] = useState(false);
    const coverPage =
        data?.appealDetails.appealApproachCalculationData.exportAppealsPackage?.coverPage;

    const renderAddress = (addressType: keyof CoverPageData, fields: string[]) => {
        if (!coverPage?.[addressType]) return null;

        return fields
            .map(field => coverPage[addressType]?.[field])
            .filter(Boolean)
            .join(" ");
    };

    const renderContent = (config: DisplayConfig) => {
        switch (config.type) {
            case "header":
                return (
                    <Row alignmentHorizontal="justify">
                        <Text type="h200">{config.title}</Text>
                        <Button type="tertiary" onClick={() => setOpenEditCoverModal(true)}>
                            Edit
                        </Button>
                    </Row>
                );

            case "single":
                return (
                    <>
                        <Text>{config.label}</Text>
                        <Text type="h50">{coverPage?.[config.field!]}</Text>
                    </>
                );

            case "row":
                return (
                    <Row alignmentHorizontal="justify">
                        {config.items?.map((item, index) => (
                            <Box key={index} width="50%">
                                <Text>{item.label}</Text>
                                <Text type="h50">
                                    {item.type === "address"
                                        ? renderAddress(item.addressType!, item.fields!)
                                        : typeof coverPage?.[item.field!] === "object"
                                          ? JSON.stringify(coverPage?.[item.field!])
                                          : coverPage?.[item.field!]}
                                </Text>
                            </Box>
                        ))}
                    </Row>
                );

            default:
                return null;
        }
    };

    return (
        <>
            {openEditCoverModal && (
                <EditCoverPage
                    open={openEditCoverModal}
                    onClose={() => setOpenEditCoverModal(false)}
                    immutableInitialData={data}
                />
            )}
            <Box type="outline" width="50vw" spacingInset="400" height="40vh" overflowY="scroll">
                {displayCoverPageConfig.map((config, index) => (
                    <React.Fragment key={config.id}>
                        {renderContent(config)}
                        {index < displayCoverPageConfig.length - 1 && <Space size="s" />}
                    </React.Fragment>
                ))}
            </Box>
        </>
    );
};
